import { ACTIONS } from "./Actions";

const reducers = (state, action) => {
  switch (action.type) {
    case ACTIONS.CMTSDATA:
      return {
        ...state,
        cmtsData: action.payload,
      };
    case ACTIONS.GETRADARDATAACTION:
      return {
        ...state,
        getRadarData: action.payload,
      };
    case ACTIONS.GROUPRADARID:
      return {
        ...state,
        groupRadarIdGlobalState: action.payload,
      };
    case ACTIONS.CONTENTCARDDATA:
      return {
        ...state,
        contentData: action.payload,
      };
    case ACTIONS.LANGFORTRANSSTATE:
      return {
        ...state,
        langForTransState: action.payload,
      };
      case ACTIONS.ISAUTOTRANS:
      return {
        ...state,
        isAutoTrans: action.payload,
      };
      return {
        ...state,
        isAutoTrans: action.payload,
      };
      
    case ACTIONS.LANGLISTOPTIONS:
      return {
        ...state,
        langListOpts: action.payload,
      };
    case ACTIONS.TAGS:
      return {
        ...state,
        tags: action.payload,
      };

    case ACTIONS.CONTENTSETTINGS:
      return {
        ...state,
        contentSettings: action.payload,
      };
    case ACTIONS.CURRENTINDEXEDITINGHISTORY:
      return {
        ...state,
        currentIndexEditingHistory: action.payload,
      };

      case ACTIONS.ISLOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case ACTIONS.CONTENTTYPES:
      return {
        ...state,
        contentTypes: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD1:
      return {
        ...state,
        comp1: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD2:
      return {
        ...state,
        comp2: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD3:
      return {
        ...state,
        comp3: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD4:
      return {
        ...state,
        comp4: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD5:
      return {
        ...state,
        comp5: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD6:
      return {
        ...state,
        comp6: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD7:
      return {
        ...state,
        comp7: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD8:
      return {
        ...state,
        comp8: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD9:
      return {
        ...state,
        comp9: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD10:
      return {
        ...state,
        comp10: action.payload,
      };
      case ACTIONS.GETWHOLEHTMLCARD11:
      return {
        ...state,
        comp11: action.payload,
      };
      case ACTIONS.ISTRANSLATED:
      return {
        ...state,
        isTranslated: action.payload,
      };
      case ACTIONS.DATAFORTRANSLATIONCARDBODY:
      return {
        ...state,
        dataForTranslationCardBody: action.payload,
      };
      case ACTIONS.DATAFORTRANSLATIONTYPEIMAGE:
      return {
        ...state,
        contentTypeImageSrc: action.payload,
      };
      case ACTIONS.DATAFORTRANSLATIONFROMCARDHEADER:
      return {
        ...state,
        dataForTranslationFromCardHeader: action.payload,
      };
      case ACTIONS.CROWDSOURCED:
      return {
        ...state,
        crowdsourced: action.payload,
      };
      case ACTIONS.SET_PDF_EXPORT_LOADING:
      return {
        ...state,
        pdfExportLoading: action.payload,
      };
      case ACTIONS.SET_PUBLIC_PHENOMENA_GROUPS:
      return {
        ...state,
        publicPhenomenaGroupsActived: action.payload,
      };
      case ACTIONS.SET_3RD_PARTY_PHENOMENA_GROUPS:
      return {
        ...state,
        thirdPartyPhenomenaGroupsActived: action.payload,
      };
      case ACTIONS.SET_USER_GROUPS:
      return {
        ...state,
        userGroups: action.payload,
      };
      case ACTIONS.SET_RADAR_ID:
      return {
        ...state,
        radarId: action.payload,
      };
    default:
      return state;
  }
};

export default reducers;
